import { useHealthInsuranceContext } from 'contexts/HealthInsuranceContext';
import { DarkTooltip } from '@portal/ui-library';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';
import { Button } from '@mui/material';

export const ValidationError = () => {
  const { state } = useHealthInsuranceContext();

  // Get all error messages for screen reader announcement
  const getAllErrorMessages = () => {
    const errorMessages: string[] = [];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Array.from(state.validationResults).forEach(([key, value]) => {
      if (!value?.success && value?.error?.issues[0].message) {
        errorMessages.push(value.error.issues[0].message);
      }
    });
    return errorMessages;
  };

  const getErrorTextForScreenreader = () => {
    const currentErrorCount = state.validationResults.size;
    const errorMessages = getAllErrorMessages();

    if (currentErrorCount > 0) {
      // Create comprehensive error announcement
      const errorCount = errorMessages.length;
      return errorCount === 1
        ? `Ein Fehler gefunden: ${errorMessages[0]}`
        : `${errorCount} Fehler gefunden: ${errorMessages.join('. ')}`;
    } else {
      // Announce when all errors are cleared
      return 'Alle Fehler behoben';
    }
  };

  if (state.validationResults.size > 0) {
    const getErrorList = () => {
      const listItems = Array.from(state.validationResults).map(([key, value]) => (
        <ListItem sx={{ p: 0.5 }} key={key} role="alert">
          <Typography className="text-sm font-normal">
            {!value?.success && value?.error?.issues[0].message}
          </Typography>
        </ListItem>
      ));
      return <List sx={{ p: 0 }}>{listItems}</List>;
    };

    const errorMessages = getAllErrorMessages();
    const errorCount = errorMessages.length;

    return (
      <>
        {/* ARIA Live Region for screen reader announcements */}
        <div
          aria-live="polite"
          aria-atomic="true"
          className="sr-only"
          role="status"
          aria-label={getErrorTextForScreenreader()}
        >
          <Typography className="text-sm font-normal">{getErrorTextForScreenreader()}</Typography>
        </div>

        <div
          className="flex items-center justify-end gap-[8px]"
          role="alert"
          aria-label={`${errorCount} Validierungsfehler gefunden`}
        >
          <DarkTooltip
            children={
              <Button
                id="validationErrorButton"
                aria-label={getErrorTextForScreenreader()}
                variant="outlined"
                color="primary"
                size="large"
                className="text-danger-60"
                onClick={() => {
                  setTimeout(() => {
                    const firstError = document.querySelector('[aria-invalid="true"]');
                    if (firstError) {
                      (firstError as HTMLElement).focus();
                    }
                    const hasDownloaded = Array.from(state.validationResults.keys()).find(
                      (key: string) =>
                        key.toString().includes('hasDownloadedContractInformationDocument')
                    );
                    if (hasDownloaded) {
                      const downloadDocument = document.getElementById('downloadDocument');
                      if (downloadDocument) {
                        downloadDocument.focus();
                      }
                    }
                  }, 500);
                }}
                startIcon={<InfoIcon />}
              >
                Eingaben korrigieren
                {state.validationResults.size > 1 && ` (${state.validationResults.size})`}
              </Button>
            }
            title={getErrorList()}
            arrow
            placement="top"
          />
        </div>
      </>
    );
  }

  return <></>;
};
